export const USER_MUTATION = { SET_USER_INFO: 'setUserInfo' }
